/* tslint:disable */
/* eslint-disable */

import * as FtcCommonTypes from "ftc-common/javaTypes";
import * as FirstCloudCommonTypes from "first-cloud-common/javaTypes";
import * as FirstCommonTypes from "first-common/javaTypes";

export interface Avatar {
    avatarId: string;
    team: Team;
    upload: CloudUpload;
    submission: AvatarSubmission;
    backgroundColor: string;
    createdAt: DateAsNumber;
    createdBy: string;
    modifiedAt: DateAsNumber;
    modifiedBy: string;
}

export interface Championship {
    cmpId: string;
    season: Season;
    name: string;
    event?: Event;
    createdAt: DateAsNumber;
    createdBy: string;
    modifiedAt: DateAsNumber;
    modifiedBy: string;
}

export interface EventRequest {
    requestId: string;
    status: EventRequestStatus;
    region: Region;
    requestType: EventRequestType;
    type: TardisEventType;
    leagueId: string;
    league: League;
    hqInitiated: boolean;
    name: string;
    style: EventStyle;
    start: string;
    end: string;
    country: string;
    state: string;
    city: string;
    timezone: string;
    noVenue: boolean;
    venue: string;
    eventWebsite: string;
    venueWebsite: string;
    moreEventsLikely: boolean;
    address: string;
    address2: string;
    capacity: number;
    reservedCapacity: number;
    zip: string;
    liveStreamUrl: string;
    fname: string;
    lname: string;
    phone: string;
    email: string;
    variations: EventVariation[];
    description: string;
    notes: string;
    comments: string;
    hqComments: string;
    code: string;
    event: Event;
    template: EventRequestTemplate;
    createdAt: DateAsNumber;
    submittedAt: DateAsNumber;
    reviewedAt: DateAsNumber;
    completedAt: DateAsNumber;
    createdBy: string;
    submittedBy: string;
    reviewedBy: string;
    completedBy: string;
}

export interface EventRequestParams {
    currentSeason: Season;
    region: Region;
    eventRequest?: EventRequest;
    init: boolean;
    requestType: EventRequestType;
    translatedType: string;
    eventTypes: TardisEventType[];
    isPdp: boolean;
    cloning: boolean;
    editableEvents?: Event[];
    eventsWithActiveRequests?: string[];
    clonable?: EventRequest[];
    leagues: League[];
    old?: EventRequest;
    usTimezoneFilter: string[];
    nextSeason?: Season;
    suggestedCode?: string;
    eventTypeMap: { [P in TardisEventType]?: string };
    variationConfig: EventVariationConfig;
    requester: UserAccount;
    pilotRegion: boolean;
}

export interface Match extends BaseMatch, FtcCommonTypes.Comparable<Match> {
    matchId: string;
    event: Event;
    field: number;
    tournamentLevel: FtcCommonTypes.TournamentLevel;
    series: number;
    number: number;
    deleted: boolean;
    status: MatchStatus;
    stations: MatchStation[];
    scores: MatchScore[];
    elimsAlliances: ElimsMatchAlliance[];
    createdAt: DateAsNumber;
    modifiedAt: DateAsNumber;
    createdBy: string;
    modifiedBy: string;
}

export interface RegionAdvancementConfig {
    regionId: string;
    region: Region;
    cmp: Championship;
    advancementCount: number;
    cmpSlotCount: number;
    createdAt: DateAsNumber;
    createdBy: string;
    modifiedAt: DateAsNumber;
    modifiedBy: string;
}

export interface Release extends FtcCommonTypes.Comparable<Release> {
    name: string;
    season: Season;
    summary: string;
    details: string;
    attachments: CloudUpload[];
    _public: boolean;
    deleted: boolean;
    createdAt: DateAsNumber;
    modifiedAt: DateAsNumber;
    createdBy: string;
    modifiedBy: string;
}

export interface TeamAdvancement {
    slotId: string;
    eventId: string;
    slot: AdvancementOrderSlot;
    event: Event;
    team: Team;
    status: FtcCommonTypes.AdvancementStatus;
    createdBy: string;
    createdAt: DateAsNumber;
    modifiedBy: string;
    modifiedAt: DateAsNumber;
}

export interface UpdateChannel {
    seasonId: string;
    season: Season;
    name: string;
    config: CloudUpload;
    keyPairRaw: Record<string, string>;
    token: string;
    version: string;
    parameters: Record<string, string>;
    _public: boolean;
    deleted: boolean;
    createdAt: DateAsNumber;
    modifiedAt: DateAsNumber;
    createdBy: string;
    modifiedBy: string;
}

export interface PreferencingResult {
    runId: string;
    teamId: string;
    run: PreferencingRun;
    team: Team;
    automatedEvent: Event;
    overrideEvent: Event;
    status: PreferencingResultStatus;
    resultData: PreferencingResultData;
    moveStatus: PreferencingResultStatus;
    notes: string;
    createdAt: DateAsNumber;
    modifiedAt: DateAsNumber;
    modifiedBy: string;
}

export interface PreferencingRun {
    runId: string;
    contextType: PreferencingContextType;
    contextId: string;
    scheduled: boolean;
    scheduledTime: string;
    eventApprovalCutoff: string;
    startTime: DateAsNumber;
    status: PreferencingRunStatus;
    parameters: PreferencingRunParams;
    runData: PreferencingRunData;
    createdAt: DateAsNumber;
    modifiedAt: DateAsNumber;
    createdBy: string;
    modifiedBy: string;
}

export interface PreferencingSourceApproval {
    eventId: string;
    event: Event;
    approvedAt: DateAsNumber;
    notes: string;
    createdAt: DateAsNumber;
    modifiedAt: DateAsNumber;
    createdBy: string;
    modifiedBy: string;
}

export interface PreferencingTargetCapacity {
    eventId: string;
    event: Event;
    slots: number;
    createdAt: DateAsNumber;
    modifiedAt: DateAsNumber;
    createdBy: string;
    modifiedBy: string;
}

export interface RunSizeEstimate {
    events: number;
    teams: number;
    teamsAndNext: number;
}

export interface TeamEventPreference {
    preferenceId: string;
    team: Team;
    contextType: PreferencingContextType;
    contextId: string;
    preferenceData: TeamPreferenceData;
    createdAt: DateAsNumber;
    modifiedAt: DateAsNumber;
    createdBy: string;
    modifiedBy: string;
}

export interface EventVideoConfig {
    videoConfigId: string;
    event: Event;
    shortTermHost: VodHost;
    shortTermData: string;
    longTermHost: VodHost;
    longTermData: string;
    videos: EventVideo[];
    createdAt: DateAsNumber;
    modifiedAt: DateAsNumber;
    createdBy: string;
    modifiedBy: string;
}

export interface ManualPreferencingRunInfoData {
    lastScheduledRun: PreferencingRun;
    targets: Event[];
    capacities: PreferencingTargetCapacity[];
    currentAssignments: Record<string, Team[]>;
    previousResults: PreferencingResult[];
    results: PreferencingResult[];
    pendingAssignmentRun: DateAsNumber;
    prefs: TeamEventPreference[];
}

export interface ManualPreferencingTeamData {
    team: Team;
    preferences: TeamEventPreference;
    declinedRuns: string[];
    unpreferencedRuns: string[];
    preferencingResults: PreferencingResult[];
    events: Event[];
    advancementRanks: TeamAdvancement[];
}

export interface PreferencingRunInfoData {
    eacs: EventAdvancementConfig[];
    newEacs: EventAdvancementConfig[];
    approvals: PreferencingSourceApproval[];
    advancing: TeamAdvancement[];
    next: TeamAdvancement[];
    prefs: Record<string, TeamPreferenceData>;
    targets: Event[];
    capacities: PreferencingTargetCapacity[];
    estimate: RunSizeEstimate;
    total: number;
    estimatedNewSlots: Record<string, number>;
    estimatedAvailableSlots: Record<string, number>;
    actualSlots: Record<string, number>;
    droppedTeams: Record<string, number>;
    estimatedTotalRunPercent: number;
    approvedRunPercent: number;
    output: PreferencingRunOutput;
    pendingAssignmentRun: DateAsNumber;
    runData: PreferencingRunData;
    previousAssignmentCounts: Record<string, number>;
    carryTeams: string[];
    slotsUsed: Record<string, number>;
    fcmpSlotsUsed: Record<string, number>;
    previousAssignedTeams: string[];
    previousDeclines: string[];
    willBeRemoved: string[];
    will2ndRoundFcmpBust: string[];
}

export interface PreferencingRunOutput {
    results: PreferencingResult[];
    preferences: LockedTeamEventPreference[];
    configs: LockedAdvancementConfig[];
    capacities: LockedPreferencingTargetCapacity[];
}

export interface AdvancementGridData {
    event: Event;
    configs: EventAdvancementConfig[];
    teams: Record<string, EventParticipant[]>;
    data: Record<string, AdvancementSlot[]>;
    declines: Record<string, AdvancementDecline>;
    manual: number[];
    slotInfos: Record<string, AdvancementOrderSlotCriteriaWrapper>[];
}

export interface AdvancementOrderSlotCriteriaWrapper {
    slot: AdvancementOrderSlot;
    criteria: string;
}

export interface RequestSubmission {
    request: EventRequest;
    message: string;
    success: boolean;
    error: boolean;
}

export interface AvatarReviewData {
    pending: number;
    skipped: number;
    batch: AvatarSubmission[];
    ttl: number;
    teamApprovedCounts: Record<string, number>;
    urlMap: Record<string, string>;
    reviewers: Record<string, UserAccount>;
}

export interface LocalDownloadInfo {
    platform: DownloadPlatform;
    fileName: string;
    fileSize: string;
}

export interface GeocodeParams {
    venue: string;
    street: string;
    city: string;
    county: string;
    state: string;
    country: string;
    postalcode: string;
}

export interface Team extends Geocoded {
    teamId: string;
    teamExternalId: number;
    teamExternalProfileId: number;
    season: Season;
    number: number;
    allNumbers: number[];
    longName?: string;
    shortName: string;
    school: string;
    city: string;
    stateProv: string;
    country: string;
    coordinates: any;
    robotName: string;
    rookieYear: number;
    website: string;
    paid: boolean;
    demoTeam: boolean;
    deleted: boolean;
    region: Region;
    altProgramTeam: Team;
    createdAt: DateAsNumber;
    modifiedAt: DateAsNumber;
    createdBy: string;
    modifiedBy: string;
    displayNumber: string;
}

export interface CloudUpload extends Upload {
    uploadId: string;
    uploadKey: UploadReference;
    filename: string;
    contentType: string;
    metadata: string;
    byteSize: number;
    checksum: string;
    isPublic: boolean;
    createdAt: DateAsNumber;
    modifiedAt: DateAsNumber;
}

export interface AvatarSubmission {
    submissionId: string;
    team: Team;
    upload: CloudUpload;
    submissionNumber: number;
    status: AvatarSubmissionStatus;
    notes: string;
    hqComments: string;
    createdAt: DateAsNumber;
    createdBy: string;
    reviewedAt: DateAsNumber;
    reviewedBy: string;
    reviewHistory: AvatarReview[];
    modifiedAt: DateAsNumber;
    modifiedBy: string;
}

export interface Season extends TardisSeasonId, FirstCommonTypes.Serializable {
    seasonId: string;
    yearString: string;
    cmpYear: number;
    startYear: number;
    program: FirstCommonTypes.Program;
    gameName: string;
    kickoff: DateAsNumber;
    deleted: boolean;
    createdAt: DateAsNumber;
    modifiedAt: DateAsNumber;
}

export interface Event extends Geocoded {
    eventId: string;
    eventExternalId: number;
    season: Season;
    region: Region;
    code: string;
    startDate: string;
    endDate: string;
    submissionStart: DateAsNumber;
    submissionEnd: DateAsNumber;
    judgingDeadline: DateAsNumber;
    lateJudgingSubmissions: boolean;
    earlyJudgeView: boolean;
    venue: string;
    streetAddress: string;
    streetAddress2: string;
    city: string;
    state: string;
    country: string;
    coordinates: any;
    name: string;
    remote: boolean;
    hybrid: boolean;
    parentEvent: Event;
    league: League;
    advancementCount: number;
    type: EventType;
    capacity: number;
    reservedCapacity: number;
    eventWebsite: string;
    venueWebsite: string;
    published: boolean;
    publishedAt: DateAsNumber;
    fieldCount: number;
    assignmentMessage: string;
    practiceActive: boolean;
    qualsPerTeam: number;
    qualsActive: boolean;
    timezoneId: string;
    timezoneName: string;
    matchEvaluator: string;
    rankAccumulator: string;
    advancementAccumulator: string;
    divisions: Division[];
    localConfig: LocalConfig[];
    divisionsPublic: boolean;
    wifiChannelAssignments: ChannelAssignmentStatus;
    liveStreams: EventLiveStream[];
    slackToken: SlackToken;
    deleted: boolean;
    createdAt: DateAsNumber;
    modifiedAt: DateAsNumber;
    createdBy: string;
    modifiedBy: string;
}

export interface Region {
    regionId: string;
    season: Season;
    name: string;
    code: string;
    regionNum: number;
    hasPartner: boolean;
    deleted: boolean;
    createdAt: DateAsNumber;
    modifiedAt: DateAsNumber;
    createdBy: string;
    modifiedBy: string;
}

export interface League {
    leagueId: string;
    region: Region;
    code: string;
    name: string;
    remote: boolean;
    location: string;
    rankAccumulator: string;
    createdAt: DateAsNumber;
    modifiedAt: DateAsNumber;
    createdBy: string;
    modifiedBy: string;
    parent: League;
    children: League[];
}

export interface EventRequestTemplate {
    templateId: string;
    region: Region;
    version: string;
    country: string;
    createdAt: DateAsNumber;
    createdBy: string;
}

export interface EventVariationConfig {
    largeSingleDivision: number;
    largeDualDivision: number;
}

export interface UserAccount extends FirstCommonTypes.Serializable {
    userAccountId: string;
    email: string;
    firstName: string;
    lastName: string;
    acceptedTermsAt: Record<string, DateAsNumber>;
}

export interface MatchStatus {
    matchId: string;
    match: Match;
    loadTime: DateAsNumber;
    startTime: DateAsNumber;
    refCommitTime: DateAsNumber;
    scorekeeperCommitTime: DateAsNumber;
    postTime: DateAsNumber;
    refereeReview: boolean;
    cycleTime: number;
    videoURL: string;
    random: number;
    scheduledStart: DateAsNumber;
    details: Record<string, any>;
    createdAt: DateAsNumber;
    modifiedAt: DateAsNumber;
    createdBy: string;
    modifiedBy: string;
}

export interface BaseMatch {
}

export interface AdvancementOrderSlot {
    slotId: string;
    season: Season;
    remote: boolean;
    slot: number;
    slotType: AdvancementSlotType;
    award: Award;
    awardCategory: AwardCategory;
    place: number;
    sizeCategory: AdvancementSizeCategory;
    createdBy: string;
    createdAt: DateAsNumber;
    modifiedBy: string;
    modifiedAt: DateAsNumber;
}

export interface PreferencingResultData {
    teamIndex: number;
    assignmentIndex: number;
    effectiveSlot: number;
    manual: boolean;
    previousAssignments: Move[];
}

export interface PreferencingRunParams {
    targetSlotsOverride: Record<string, number>;
}

export interface PreferencingRunData {
    start: DateAsNumber;
    end: DateAsNumber;
    declinedTeams: string[];
    unpreferencedTeams: string[];
    removedTeams: string[];
    thirdTimes: string[];
    skippedNextTeams: string[];
    preferenceOrder: Record<string, number>;
    sourceTeamCount: Record<string, number>;
    allTeamsCount: number;
    allTeamsAutoCount: number;
    allTeamsManualCount: number;
    unreplacedDeclines: number;
    unreplacedRemovals: number;
    allocationSums: AllocationSums;
    restrictionCount: number;
    runSlots: number;
    runPercent: number;
    calculatedAvailableSlots: Record<string, number>;
    droppedAssignmentCounts: Record<string, number>;
    teamsAssigned: number;
    teamsUnassigned: number;
    noFcmpHistDenom: number;
    preferenceHist: Record<string, number>;
    noFcmpPreferenceHist: Record<string, number>;
    slotsFilled: Record<string, number>;
    slotsUnfilled: Record<string, number>;
}

export interface TeamPreferenceData {
    events: string[];
    options: TeamPreferenceOption[];
    notes: string;
    siblings: string;
}

export interface Geocoded {
}

export interface UploadReference {
}

export interface Upload {
}

export interface TardisSeasonId {
}

export interface EventType {
    id: number;
    name: string;
    scoringAware: boolean;
    localAware: boolean;
}

export interface SlackToken {
    teamId: string;
    teamName: string;
    token: string;
}

export interface MatchStation {
    match: Match;
    matchId: string;
    alliance: number;
    station: number;
    team: Team;
    surrogate: boolean;
    onField: boolean;
    card: Card;
    noShow: boolean;
    createdAt: DateAsNumber;
    modifiedAt: DateAsNumber;
    createdBy: string;
    modifiedBy: string;
}

export interface MatchScore {
    match: Match;
    matchId: string;
    alliance: number;
    score: number;
    penaltyCommitted: number;
    total: number;
    details: FtcCommonTypes.ScoreDetail;
    createdAt: DateAsNumber;
    modifiedAt: DateAsNumber;
    createdBy: string;
    modifiedBy: string;
}

export interface ElimsMatchAlliance {
    match: Match;
    matchId: string;
    matchAlliance: number;
    eventAlliance: Alliance;
}

export interface Award {
    awardId: string;
    season: Season;
    isTeamAward: boolean;
    category: AwardCategory;
    name: string;
    awardTypeId: number;
    awardSubtypeId: number;
    displayOrder: number;
    displayOrderOnline: number;
    allowManualEntry: boolean;
    editable: boolean;
    ordered: boolean;
    script: string;
    hidden: boolean;
    deleted: boolean;
    createdAt: DateAsNumber;
    modifiedAt: DateAsNumber;
    type: number;
}

export interface AllocationSums {
    total: number;
    fcmp: number;
}

export interface EventVideo {
    videoId: string;
    type: VideoType;
    url: string;
    startTime: DateAsNumber;
    endTime: DateAsNumber;
    manual: boolean;
    config: EventVideoConfig;
    errata: EventVideoError[];
    createdAt: DateAsNumber;
    modifiedAt: DateAsNumber;
    createdBy: string;
    modifiedBy: string;
}

export interface EventAdvancementConfig {
    eventId: string;
    event: Event;
    advancesTo?: Event;
    hostTeam?: Team;
    advancementCount: number;
    reserveSlots: number;
    advanceHost: boolean;
    published: boolean;
    createdAt: DateAsNumber;
    createdBy: string;
    modifiedAt: DateAsNumber;
    modifiedBy: string;
}

export interface LockedTeamEventPreference {
    runId: string;
    teamId: string;
    run: PreferencingRun;
    team: Team;
    preferenceData: TeamPreferenceData;
    createdAt: DateAsNumber;
}

export interface LockedAdvancementConfig {
    runId: string;
    eventId: string;
    run: PreferencingRun;
    event: Event;
    advancementCount: number;
    reserveSlots: number;
    createdAt: DateAsNumber;
}

export interface LockedPreferencingTargetCapacity {
    runId: string;
    eventId: string;
    run: PreferencingRun;
    event: Event;
    slots: number;
    createdAt: DateAsNumber;
}

export interface EventParticipant {
    eventId: string;
    teamId: string;
    event: Event;
    team: Team;
    competing: FtcCommonTypes.CompetingType;
    division: number;
    inspireEligible: boolean;
    promoteEligible: boolean;
    deleted: boolean;
    advancement: FtcCommonTypes.AdvancementEligibility;
}

export interface AdvancementSlot {
    eventCode: string;
    advancement: FtcCommonTypes.CommonAdvancement;
    slotNumber: number;
    declined: boolean;
    replacement: boolean;
    manualDate: DateAsNumber;
}

export interface AdvancementDecline {
    eventId: string;
    teamId: string;
    event: Event;
    team: Team;
    fill: AdvancementDeclineFill;
    feedingEvent: Event;
    replacementTeam: Team;
    createdBy: string;
    createdAt: DateAsNumber;
}

export interface AvatarReview {
    userId: string;
    comment: string;
    timestamp: number;
    op: AvatarReviewOp;
}

export interface Division {
    eventId: string;
    id: number;
    deletedAt: DateAsNumber;
    name: string;
    abbrev: string;
}

export interface LocalConfig {
    eventId: string;
    event: Event;
    key: string;
    value: string;
    createdAt: DateAsNumber;
    modifiedAt: DateAsNumber;
}

export interface EventLiveStream {
    url: string;
    date: string;
    label: string;
}

export interface Alliance extends FtcCommonTypes.Comparable<Alliance> {
    event: Event;
    eventId: string;
    seed: number;
    interDivisionCardCarry: boolean;
    allianceName: string;
    allianceAbbrev: string;
    members: AllianceMember[];
}

export interface Move {
    previousEvent: string;
    newEvent: string;
    createdAt: DateAsNumber;
    createdBy: string;
    modifiedAt: DateAsNumber;
    modifiedBy: string;
}

export interface EventVideoError {
    errataId: string;
    video: EventVideo;
    startOffset: number;
    correction: number;
    createdAt: DateAsNumber;
    modifiedAt: DateAsNumber;
    createdBy: string;
    modifiedBy: string;
}

export interface AllianceMember {
    eventId: string;
    seed: number;
    alliance: Alliance;
    spot: number;
    team: Team;
}

export type DateAsNumber = number;

export const enum EventVariation {
    DUAL_DIVISION = "DUAL_DIVISION",
    MATCH_COUNT = "MATCH_COUNT",
    TEAM_COUNT = "TEAM_COUNT",
    SINGLE_DIVISION_TEAM_COUNT = "SINGLE_DIVISION_TEAM_COUNT",
}

export const enum AvatarReviewOp {
    APPROVE = "APPROVE",
    REJECT = "REJECT",
    PURGE = "PURGE",
    SKIP = "SKIP",
    SECOND_OPINION = "SECOND_OPINION",
}

export const enum DownloadPlatform {
    WINDOWS_AMD64 = "WINDOWS_AMD64",
    MACOS_AMD64 = "MACOS_AMD64",
    MACOS_AARCH64 = "MACOS_AARCH64",
    LINUX_AMD64 = "LINUX_AMD64",
    LINUX_AARCH64 = "LINUX_AARCH64",
    LINUX_AARCH32HF = "LINUX_AARCH32HF",
    ALL_PLATFORMS = "ALL_PLATFORMS",
}

export const enum EventRequestStatus {
    INCOMPLETE = "INCOMPLETE",
    PENDING = "PENDING",
    APPROVED = "APPROVED",
    REJECTED = "REJECTED",
    CHANGE = "CHANGE",
    COMPLETED = "COMPLETED",
    WITHDRAWN = "WITHDRAWN",
}

export const enum EventRequestType {
    CREATE = "CREATE",
    EDIT = "EDIT",
    DELETE = "DELETE",
    RESTORE = "RESTORE",
    CODE_CHANGE = "CODE_CHANGE",
}

export const enum TardisEventType {
    FTC_SCRIMMAGE = "FTC_SCRIMMAGE",
    FTC_LEAGUE_MEET = "FTC_LEAGUE_MEET",
    FTC_QUALIFIER = "FTC_QUALIFIER",
    FTC_LEAGUE_TOURNAMENT = "FTC_LEAGUE_TOURNAMENT",
    FTC_SUPER_QUALIFIER = "FTC_SUPER_QUALIFIER",
    FTC_CHAMPIONSHIP = "FTC_CHAMPIONSHIP",
    FTC_SCORING_PRACTICE = "FTC_SCORING_PRACTICE",
    FTC_OFF_SEASON = "FTC_OFF_SEASON",
    FTC_INTERVIEW = "FTC_INTERVIEW",
    FTC_KICKOFF = "FTC_KICKOFF",
    FTC_WORKSHOP = "FTC_WORKSHOP",
    FTC_DEMO = "FTC_DEMO",
    FTC_VOLUNTEER = "FTC_VOLUNTEER",
    FTC_PRACTICE = "FTC_PRACTICE",
    FTC_FIRST_CHAMPIONSHIP = "FTC_FIRST_CHAMPIONSHIP",
    FTC_AWARDS_ONLY = "FTC_AWARDS_ONLY",
    FTC_PREMIER = "FTC_PREMIER",
    FTC_PILOT = "FTC_PILOT",
    FLLC_CHAMPIONSHIP = "FLLC_CHAMPIONSHIP",
    FLLC_OPEN_CHAMPIONSHIP = "FLLC_OPEN_CHAMPIONSHIP",
    FLLC_QUALIFYING = "FLLC_QUALIFYING",
    FLLC_LOCAL = "FLLC_LOCAL",
    FLLC_WORLD_FESTIVAL = "FLLC_WORLD_FESTIVAL",
    FLLE_CHAMPIONSHIP = "FLLE_CHAMPIONSHIP",
    FLLE_OFFICIAL_EXPO = "FLLE_OFFICIAL_EXPO",
    FLLE_LOCAL = "FLLE_LOCAL",
    FLLE_WORLD_FESTIVAL = "FLLE_WORLD_FESTIVAL",
}

export const enum EventStyle {
    TRADITIONAL = "TRADITIONAL",
    HYBRID = "HYBRID",
    REMOTE = "REMOTE",
}

export const enum PreferencingResultStatus {
    PENDING = "PENDING",
    APPROVED = "APPROVED",
    ASSIGNED = "ASSIGNED",
}

export const enum PreferencingContextType {
    SEASON = "SEASON",
    REGION = "REGION",
}

export const enum PreferencingRunStatus {
    SCHEDULED = "SCHEDULED",
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
}

export const enum VodHost {
    TWITCH = "TWITCH",
    YOUTUBE = "YOUTUBE",
    RAW = "RAW",
}

export const enum AvatarSubmissionStatus {
    PENDING = "PENDING",
    APPROVED = "APPROVED",
    WITHDRAWN = "WITHDRAWN",
    REJECTED = "REJECTED",
    REGION_REJECTED = "REGION_REJECTED",
    PURGED = "PURGED",
}

export const enum ChannelAssignmentStatus {
    NONE = "NONE",
    PRIVATE = "PRIVATE",
    PUBLIC = "PUBLIC",
}

export const enum AdvancementSlotType {
    HOST = "HOST",
    AWARD = "AWARD",
    RANK = "RANK",
    AWARD_CATEGORY = "AWARD_CATEGORY",
    NEXT_AWARD = "NEXT_AWARD",
    POINTS = "POINTS",
}

export const enum AwardCategory {
    INSPIRE = "INSPIRE",
    MCI = "MCI",
    TA = "TA",
    THINK = "THINK",
    ROBOT = "ROBOT",
    OTHER = "OTHER",
}

export const enum AdvancementSizeCategory {
    SMALL = "SMALL",
    SINGLE_DIVISION = "SINGLE_DIVISION",
    DUAL_DIVISION = "DUAL_DIVISION",
    ANY = "ANY",
}

export const enum Card {
    YELLOW = "YELLOW",
    RED = "RED",
    SECOND_YELLOW = "SECOND_YELLOW",
}

export const enum TeamPreferenceOption {
    SIBLING = "SIBLING",
    MULTIPLE = "MULTIPLE",
    DECLINE = "DECLINE",
}

export const enum VideoType {
    SHORT_TERM = "SHORT_TERM",
    LONG_TERM = "LONG_TERM",
    MANUAL = "MANUAL",
}

export const enum AdvancementDeclineFill {
    FILL = "FILL",
    OPEN = "OPEN",
}
